var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-checkbox',{key:_vm.id,attrs:{"id":_vm.id,"name":_vm.id,"disabled":_vm.checkDisabled,"switch":_vm.typeSwitch},on:{"change":function($event){return _vm.onChange()}},model:{value:(_vm.valueCheckbox),callback:function ($$v) {_vm.valueCheckbox=$$v},expression:"valueCheckbox"}},[_vm._v(" "+_vm._s(_vm.textCheckbox)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }